import styled from 'styled-components';

interface IContainerProps {
  isDesktop: boolean;
}

export const TextContainer = styled.div<IContainerProps>`
  display: flex;
  width: 100%;
  align-items: center;
  padding: ${(props) => (props.isDesktop ? '0 60px' : 0)};
  flex-flow: ${(props) => (props.isDesktop ? 'row' : 'column-reverse')};
`;

export const WrapContentCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ContainerStyled = styled.div<IContainerProps>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: ${(props) => (props.isDesktop ? '40px 0 0' : '20px 0 0')};
  align-items: ${(props) => (props.isDesktop ? 'flex-end' : 'center')};
  flex-flow: ${(props) => (props.isDesktop ? 'row' : 'column')};
`;
